/*
import { AttributionPortfolio } from "../../apis/models/attribution"
import { IssuerHoldings, IssuerHoldingsByStrategy, SecurityHoldings } from "../../apis/models/company"
import { Strategy } from "../../apis/models/meta"
import { ListColumn, ListColumnCriteriaColumn, RowCriteria } from "../../views/lists/types/listTypes"
*/

export function checkStrategyPermission(
  item, //: Strategy | ListColumn | ListColumnCriteriaColumn | RowCriteria | IssuerHoldingsByStrategy | IssuerHoldings | SecurityHoldings | AttributionPortfolio,
  userId //: number
) {
  let check = false
  if ("imdb_code" in item) {
    check = item.imdb_code === "SSGPP"
  } else if ("code" in item) {
    check = item.code === "SSGPP"
  } else if ("data" in item) {
    check = item.dataField === "strategyId" && (item.data === 273 || (Array.isArray(item.data) && item.data.includes(273)))
  } else if ("strategyCode" in item) {
    check = item.strategyCode === "SSGPP"
  } else if ("abbrHeaderText" in item) {
    check = item.abbrHeaderText === "SSGPP"
  } else if ("dataField" in item) {
    check = item.dataField === "portfolioPercentages_273"
  } else if ("strategyId" in item) {
    check = item.strategyId === 273
  } else if ("strategyShortName" in item) {
    check = item.strategyShortName === "SSGPP"
  }

  return !check || [16, 436].includes(userId) // Mark	Thompson, Michael	Cody
}